// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__XxiWV","errorLogs":"styles_errorLogs__2r0ss"};